import React, {Component, Fragment} from 'react';
import Modal from '../UI/Modal';
import {classNamesPrefixed} from '../../../helpers/CoreHelpers';
import Collapsible from 'react-collapsible';
import {collapsibleSettings} from '../../helpers/Helpers';
import BtnPrimary from "../UI/BtnPrimary";
import BtnSecondary from "../UI/BtnSecondary";
import Input from "../Fields/Input";

class ExternalLinkField extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            link: props.input.value ? props.input.value : {}
        }
    }

    componentDidMount() {
        const {value} = this.props.input;

        if (value) {
            this.setState({
                link: value
            });
        }
    }

    showModal() {
        this.setState({
            modal: true
        });
    }

    hideModal() {
        this.setState({
            modal: false
        });
    }

    save() {
        this.props.input.onChange(this.state.link);

        this.setState({
            modal: false
        });
    }

    edit(e) {
        e.preventDefault();

        const {input} = this.props;

        this.setState({
            modal: true,
            link: input && input.value ? input.value : {}
        });
    }

    isSaveDisabled() {
        const {link} = this.state;
        return !link.url || link.url === '';
    }

    clear(e) {
        e.preventDefault();

        const {input} = this.props;

        input.onChange(null);

        this.setState({
            link: {}
        });
    }

    getModal() {

        const {modal, link} = this.state;

        return (
            <Modal
                showModal={modal}
                onClose={() => {
                    this.hideModal();
                }}
                title="Add external link"
                icon="link"
                modalFooter={
                    <div className={classNamesPrefixed({'form-actions': true})}>
                        <BtnPrimary
                            small
                            icon={"save"}
                            disabled={this.isSaveDisabled()}
                            onClick={(e) => {
                                e.preventDefault();
                                this.save();
                            }}>Save</BtnPrimary>
                    </div>
                }
            >
                {this.getUrlField()}
                <div>
                    <div
                        className={classNamesPrefixed({
                            'form-item': true,
                            'form-checkbox': true
                        })}
                    >
                        <label htmlFor="link_target">
                            Open link in new tab
                            <input
                                type="checkbox"
                                id="link_target"
                                name="link_target"
                                defaultChecked={(link && link.target ? link.target : false)}
                                onChange={(e) => {
                                    this.setState({
                                        link: {
                                            ...link,
                                            'target': e.target.checked
                                        }
                                    });
                                }}
                            />
                            <span/>
                        </label>
                    </div>
                </div>
            </Modal>
        );
    }

    getUrlField() {
        const {link, modal} = this.state;
        const {disabled,label} = this.props;
        return (
            <div
                className={classNamesPrefixed({
                    'form-item': true,
                    'form-text': true
                })}
            >

                <Input
                    label={label ? label : "Link destination"}
                    type="text"
                    id="link_url"
                    name="link_url"
                    placeholder="http://website.com"
                    value={link && link.url ? link.url : ''}
                    onChange={(e) => {
                        this.setState({
                            link: {
                                ...link,
                                'url': e.target.value
                            }
                        });
                    }}
                    onClick={(e) => {
                        if (!modal) {
                            e.preventDefault();
                            this.showModal();
                        }
                    }}
                    disabled={disabled}
                />
            </div>
        );
    }

    getTitleField() {
        const {omitTitle, input, disabled} = this.props;
        const {link} = this.state;
        if (omitTitle) {
            return;
        }
        return (
            <div
                className={classNamesPrefixed({
                    'form-item': true,
                    'form-text': true
                })}
            >
                <Input
                    label={"Link title"}
                    type="text"
                    id="link_title"
                    name="link_title"
                    placeholder="Type link title here"
                    value={input.value.title}
                    onChange={(e) => {
                        let l = {
                            ...link,
                            'title': e.target.value
                        };
                        this.setState({
                            link: l
                        });
                        this.props.input.onChange(l);
                    }}
                    disabled={disabled}
                />
            </div>
        )
    }


    getContent() {
        const {link} = this.state;
        const {
            input,
            meta: {
                touched,
                error
            },
            omitTitle,
        } = this.props;

        return (
            <Fragment>
                {this.getModal()}
                {input.value === '' ? (
                    <Fragment>
                        {!omitTitle && this.getTitleField()}
                        {this.getUrlField()}
                    </Fragment>
                ) : (
                    <div>
                        {!omitTitle && this.getTitleField(link)}
                        {this.getUrlField()}
                        <div className={classNamesPrefixed({'form-actions': true})}>
                            <BtnSecondary small onClick={this.clear.bind(this)}>Clear</BtnSecondary>
                        </div>
                    </div>
                )}
                {touched && error && <div className={classNamesPrefixed({'input-below-error': true})}>{error}</div>}
            </Fragment>
        )
    }

    render() {
        const {expanded} = this.state;
        const {
            label,
            omitCollapsible
        } = this.props;

        const content = this.getContent();
        if (omitCollapsible) return content;

        return (
            <Collapsible
                {...collapsibleSettings}
                trigger={label ? <label className={classNamesPrefixed({"trigger__label":true})}>{label}</label> : ''}
                open={expanded}
            >
                {content}
            </Collapsible>
        );
    }
}

export default ExternalLinkField;


// WEBPACK FOOTER //
// ./src/core/admin/components/Fields/ExternalLinkField.js